import '@/assets/styles/components/meet-connection-test.scss';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';

type RefType = {
	onMicrophoneStatus: () => void;
	onCameraStatus: () => void;
};

type Props = {
	src: string;
};

export const MeetConnectionOutActions = {
	cameraStatus: 'cameraStatus',
	microphoneStatus: 'microphoneStatus'
} as const;

type MeetVWOutActionsType = (typeof MeetConnectionOutActions)[keyof typeof MeetConnectionOutActions];

const MeetConnectionTestIframe = forwardRef<RefType, Props>(({ src }, ref) => {
	const iframeRef = useRef<HTMLIFrameElement | null>(null);

	const sendMessage = (payload: { type: MeetVWOutActionsType; data?: any }): void => {
		iframeRef.current?.contentWindow?.postMessage(payload, '*');
		(window as any).iframeWindow = iframeRef.current?.contentWindow;
	};

	useImperativeHandle(ref, () => ({
		onMicrophoneStatus: (status: boolean): void => {
			sendMessage({
				type: MeetConnectionOutActions.microphoneStatus,
				data: { status }
			});
		},
		onCameraStatus: (status: boolean): void => {
			sendMessage({
				type: MeetConnectionOutActions.cameraStatus,
				data: { status }
			});
		}
	}));

	useEffect(() => {
		iframeRef.current = document.getElementById('meet-iframe') as HTMLIFrameElement;
		window.addEventListener('message', () => null);
	}, []);

	return (
		<div className={'meet-connection-iframe-container'}>
			<iframe
				src={src}
				id="meet-iframe"
				className="meet-iframe"
				allow="autoplay; camera; microphone; display-capture"
				allowFullScreen
			/>
		</div>
	);
});

export default MeetConnectionTestIframe;
